
const Proje = resolve => {
    require.ensure(['../views/apps/proje/Proje'], () => {
        resolve(require('../views/apps/proje/Proje'))
    })
};
const ProjeDetay = resolve => {
    require.ensure(['../views/apps/proje/ProjeDetay'], () => {
        resolve(require('../views/apps/proje/ProjeDetay'))
    })
};
const ProjeTanimla = resolve => {
    require.ensure(['../views/apps/proje/ProjeTanimla'], () => {
        resolve(require('../views/apps/proje/ProjeTanimla'))
    })
};
const ProjelerListe = resolve => {
    require.ensure(['../views/apps/proje/ProjelerListe'], () => {
        resolve(require('../views/apps/proje/ProjelerListe'))
    })
};
const ProjeDuzenle = resolve => {
    require.ensure(['../views/apps/proje/ProjeDuzenle'], () => {
        resolve(require('../views/apps/proje/ProjeDuzenle'))
    })
};
const KategoriTanimlama = resolve => {
    require.ensure(['../views/apps/proje/kategori/KategoriTanimlama'], () => {
        resolve(require('../views/apps/proje/kategori/KategoriTanimlama'))
    })
};

import Vue from 'vue'

Vue.component('ProjeDetay', ProjeDetay);
Vue.component('ProjeTanimla', ProjeTanimla);
Vue.component('ProjeListesi', ProjelerListe);
Vue.component('ProjeDuzenle', ProjeDuzenle);
Vue.component('ProjeKategorileri', KategoriTanimlama);
import layouts from '../layout'

export default {
    path: '/proje',
    name: 'proje',
    component: Proje,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: '/detay',
            name: 'projedetay',
            component: ProjeDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
